<template>
    <div class="sub_container">
      <div class="sub_title">
          <span style="float:left;">邮箱管理</span>
          <router-link tag="span" to="/Personal" @click.native="backup">返回上一级</router-link>
      </div>
      <div class="dl">
        <i-form ref= 'formItem' :model="formItem">
            <form-item label="邮箱" >
                <i-input  style="display:none"></i-input>
                <i-input  v-model="formItem.email_x" type="text"></i-input>
            </form-item>
            <form-item label="验证码">
                <i-input v-model="formItem.password"></i-input>
                <i class="VerificationCode" v-if="showcode" @click="getverification">获取验证码</i>
                <i class="VerificationCode" v-if="!showcode">{{count}}s</i>
            </form-item>
        </i-form>
        <button class="sub" @click="subEdit">提交</button>
      </div>
     <Modal
        v-model="modalStatus"
        title="提示"
        @on-ok="ok"
        @on-cancel="cancel">
        <p class="tc ft-16">{{modalStatusText}}</p>
    </Modal>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
import Cookies from 'js-cookie'
export default {
    name: 'changepwd',
    data () {
         var  validateuser = function(rule, value, callback){
            if(!value){
                return callback(new Error("请输入用户名"));
            }else if(!/^[a-zA-Z\d]+$/.test(value)){
                return callback(new Error("请正确输入用户名"))
            }else{
                callback();
            }
        }
        var  validatenick = function(rule, value, callback){
            if(!value){
                return callback(new Error("请输入用户名称"));
            }else if(!/^[\u4e00-\u9fa5]+$/.test(value)){
                return callback(new Error("请正确输入用户名称"))
            }else{
                callback();
            }
        }
        var validatePass = function(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        }
        var validatePassCheck = function(rule, value, callback){
            if (value === '') {
                return callback(new Error('请再次输入密码'));
            } else if (value !== vue.formItem.password) {
                return callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        }
        return {
            group:[],
            formItem:{
                email: '',
                email_x: ''
            },
            ruleValidate:{
                username    : [{validator: validateuser,trigger: 'blur'}],
                password    : [{validator: validatePass, trigger: 'blur' },{min:6,message:'请输入最少6位'}],
                rpassword   : [{validator: validatePassCheck, trigger: 'blur' },{min:6,message:'请输入最少6位'}],
            },
            showcode: true,
            count: '',
            email_code: '',
            modalStatus: false,
            modalStatusText: ''
        }
    },
    computed: {
    },
    mounted () {
        if(JSON.parse(Cookies.get('userdata')).email != ''){
            let userdata = JSON.parse(Cookies.get('userdata'))
            this.formItem.email_x = this.formatNum(userdata.email)
            this.formItem.email = userdata.email
        }
    },
    methods: {
       formatNum(data) {
            let res = data.substr(0,2)+'***'+data.substr(5,data.split('').length);
            return res
        },
        ok () {
            this.backup()
            this.$router.go(0)
            this.$router.replace({
                path: '/Personal',
                query: {
                    'paperId':'Personal'
                }
            })
            this.$Message.info('个人中心')
        },
        cancel () {
            this.$Message.info('取消');
        },
        subEdit () {
            // let session = localStorage.session
            // let username = localStorage.getItem("username")
            console.log(this.formItem.email_x)
            if(JSON.parse(Cookies.get('userdata')).email == ''){
               this.formItem.email = this.formItem.email_x
               console.log(this.formItem.email)
            }
            this.$Loading.start()
            let username = localStorage.getItem('username');
            let session = Cookies.get("session")
            var params = {}
            if(JSON.parse(Cookies.get('userdata')).email){
               params = { action: 'email_check', old_email: JSON.parse(Cookies.get('userdata')).email, email_code_check:this.email_code, web: 'pc', session: session}
            }else{
               params = {action: 'edit_email',username: username, email: this.formItem.email, email_code: this.email_code, web: 'pc',session: session}
            }
            doPost(
            params,
            (res) => {
                if(!res.status){
                  console.log(res.detail)
                  this.modalStatus = true
                  this.modalStatusText = res.detail
                  this.$Loading.finish()
                  console.log(this.modalStatusText)
                }else{
                  this.$Message.error(res.detail)
                  this.$Loading.error()
              }
            })
        },
        backup () {
            this.$store.commit('changeSub',false)
        },
        getverification () {
            // let session = localStorage.session
            // let username = localStorage.getItem("username")
            // let useremail = localStorage.useremail
            if(JSON.parse(Cookies.get('userdata')).email == ''){
               this.formItem.email = this.formItem.email_x
               console.log(this.formItem.email)
            }
            this.$Loading.start()
            let username = localStorage.getItem("username")
            let session = Cookies.get("session")
            let useremail = Cookies.get("useremail")
            let tag
            if(JSON.parse(Cookies.get('userdata')).email){
                tag = '3'
            }else{
                tag = '2'
            }
            doPost(
                {action: 'sendemail', email: this.formItem.email, username: username, session: session, tag: tag, web: 'pc'},
                (data) => {
                    this.$Message.success(data.detail)
                    if(!data.status){
                        this.email_code = data.code
                        this.$Message.success(data.detail)
                        this.getCode()
                        this.$Loading.finish()
                    }else{
                        this.$Loading.error()
                    }
                }
            )
        },
        getCode () {
            const TIME_COUNT = 60
            if(!this.timer){
                this.count = TIME_COUNT
                this.showcode = false
                this.timer = window.setInterval( ()=> {
                    if(this.count > 0 && this.count <= 60) {
                        this.count --
                    } else{
                        this.showcode = true
                        clearInterval(this.timer)
                        this.timer = null
                    }
                },1000)
            }
        }
    }

}
</script>

<style lang="stylus" scoped>
    .sub_container
        padding 20px 30px
        text-align center
    .sub_title span:nth-child(2)
        float right
    .sub_container .sub
        width 177px
        line-height 36px
        background #2BD3A0
        border 1px solid #2BD3A0
        border-radius 100px
        color #ffffff
        padding  0px 20px
        // margin-left 90px
        font-weight bold
     >>>.ivu-input
        position relative
        display inline-block
        width 300px
    .VerificationCode
        position absolute
        left 256px
        top 35px
        color #999999
        width 36px
        &:before
            content ''
            display block
            position absolute
            left -8px
            top 10px
            width 1px
            height 12px
            background #999999
        &:hover
            color #2bd3a0
    >>> .ivu-form
        padding 20px 10px
    >>> .ivu-form-item-label
        margin-right 10px
        width 60px
        text-align left
    >>> .ivu-input-wrapper
        display inline

</style>





// WEBPACK FOOTER //
// src/pages/Personal/components/changeemail.vue